module.exports = window["braintree"]["hostedFields"];